const keywords = [
    {
        "id": "user",
        "name": "Usuario Email que creó el registro"
    }, {
        "id": "wa:user",
        "name": "Usuario WhatsApp que creó el registro"
    }
]

module.exports = keywords;